import script from "./AlertNotificationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertNotificationCard.vue?vue&type=script&setup=true&lang=js"

import "./AlertNotificationCard.vue?vue&type=style&index=0&id=111c92f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111c92f3"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QInnerLoading});
